<template>
  <div style="max-width: 800px">
    <b-field :label="$gettext('form.heading.choose_activity')">
      <fob-entity-palette ref="palette" v-model="selectedType"></fob-entity-palette>
    </b-field>

    <!-- D E S C R I P T I O N -->
    <div
      class="fob-box box"
      v-if="selectedType != null"
      v-html="$gettext(selectedEntity + '.form.hinweistext')"
    ></div>

    <transition name="component-fade" mode="out-in">
      <div v-if="resourceType != null && !loading">
        <fob-entity-create-form
          @update:invalid="value => isInvalid = value"
          :showErrors="showErrors"
          :key="selectedType"
          :type="resourceType"
          :schema="selectedSchema"
          v-model="resourceData"
        ></fob-entity-create-form>

        <div style="margin-top: 40px">
          <b-field grouped>
            <p class="control">
              <button @click="requestSave" :disabled="!isDirty" class="button is-aquamarine">Speichern</button>
            </p>
            <p class="control">
              <button @click="close" class="button is-carnelian">Abbrechen</button>
            </p>
          </b-field>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import schema from '@/schema'
import store from '@/store'
import { BaseEntity } from 'fobclient/lib/entity'
import ValidateAndSave from '@/components/mixins/ValidateAndSave'
import DynamicTitle from '@/components/mixins/DynamicTitle'
import EntityPalette from '@/components/EntityPalette'

export default {
  name: 'fob-entity-create',
  mixins: [ValidateAndSave, DynamicTitle],
  data () {
    return {
      resourceTypes: schema.baseTypes,
      leurisHead: {
        inner: 'leuris:Forschungsbericht',
        complement: 'menu.create'
      },
      showErrors: false
    }
  },
  components: {
    'fob-entity-palette': EntityPalette
  },
  computed: {
    ...mapGetters({
      isDirty: 'creator/isDirty',
      loading: 'creator/isLoading',
      resourceType: 'creator/getResourceType',
      schema: 'creator/getSchema'
    }),
    resourceData: {
      get () {
        return this.$store.getters['creator/getData']
      },
      set (value) {
        this.$store.dispatch('creator/setData', value)
      }
    },
    selectedSchema () {
      return this.$store.getters['creator/getSchema']
    },
    selectedEntity () {
      let resource = this.resourceTypes.find(x => x.schema.route === this.resourceType)
      if (resource != null) {
        let className = resource.schema.className
        return className.charAt(0).toUpperCase() + className.slice(1)
      } else {
        return ''
      }
    },
    selectedType: {
      get () {
        return this.resourceType
        // if (this.resourceType === null) {
        //   return null
        // } else {
        //   const sel = this.resourceTypes.findIndex(x => x.schema.route === this.resourceType)
        //   if (sel === -1) {
        //     this.$router.replace({
        //       name: 'eintragen'
        //     })
        //     return null
        //   }
        //   return sel
        // }
      },
      set (v) {
        // the test v !== this.selectedType is necessary because when reverting
        // the dropdown state back to the current value on cancel, a new update
        // to the the selectedModel is triggered. we want neither show a warning
        // nor reset the resource to a blank state
        if (v !== this.selectedType) {
          if (this.resourceData != null && this.resourceData._dirty) {
            this.$dialog.confirm({
              message: this.$gettext(v != null ? 'warnung.create.nachricht' : 'warnung.create.abbrechen'),
              confirmText: this.$gettext('warnung.create.confirm'),
              cancelText: this.$gettext('warnung.create.cancel'),
              onConfirm: () => {
                if (v != null) {
                  this.resourceData._dirty = false
                  this.$router.push({
                    name: 'eintragen',
                    params: {
                      resourceType: v
                    }
                  })
                  this.$store.dispatch('creator/newEntity')
                } else {
                  this.$store.dispatch('creator/closeEditor')
                  this.$router.push({ name: 'eintragen' })
                }
              },
              onCancel: () => {
                this.$refs.palette.setSelection(this.selectedType)
              }
            })
          } else {
            // TODO: Refactor to DRY
            if (v !== null) {
              let orga = this.$store.getters['user/selectedOrga']
              let Constructor = schema[v].class
              let blankEntity = new Constructor({ organisationseinheit: orga })
              this.$store.dispatch('creator/setData', blankEntity)
              this.$router.push({
                name: 'eintragen',
                params: {
                  resourceType: v
                }
              })
            } else {
              this.$store.dispatch('creator/closeEditor')
              this.$router.push({ name: 'eintragen' })
            }
          }
        }
      }
    }
  },
  beforeMount () {
    if (this.resourceData != null && Object.keys(this.resourceData).length !== 0 && !(this.resourceData instanceof BaseEntity)) {
      let Constructor = this.schema.class
      let reconstructedEntity = new Constructor(this.resourceData)
      this.resourceData = reconstructedEntity
    }
  },
  methods: {
    save () {
      this.saveAndDispatch('creator/saveEntity')
        // .then(() => this.$store.dispatch('creator/newEntity'))
      this.$store.dispatch('creator/closeEditor')
    },
    close () {
      this.$refs.palette.setSelection(null)
    }
  },
  beforeRouteEnter (to, from, next) {
    const resourceType = store.getters['creator/getResourceType']
    const isDirty = store.getters['creator/isDirty']
    if (resourceType != null && to.params.resourceType !== resourceType) {
      if (isDirty && to.params.resourceType != null) {
        // IMPROVEMENT: warning here and optionally start new resource
        // BUT: beforeRouteEnter has not access to the Vue vm and thus can't
        //      translate the dialog. postponed and just silently redirect
        next({
          name: 'eintragen',
          params: {
            resourceType
          }
        })
      } else {
        next({
          name: 'eintragen',
          params: {
            resourceType
          }
        })
      }
    } else {
      if (to.params.resourceType != null) {
        const type = to.params.resourceType
        if (schema[type] != null) {
          if (isDirty) {
            store.dispatch('creator/setSchema', schema[type])
              .then(() => next())
          } else {
            store.dispatch('creator/setSchema', schema[type])
              .then(() => store.dispatch('creator/newEntity'))
              .then(() => next())
          }
        } else {
          next('/erstellen')
        }
      } else {
        next()
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.showErrors = false
    const type = to.params.resourceType
    const resourceType = store.getters['creator/getResourceType']
    const isDirty = store.getters['creator/isDirty']
    if (schema[type] != null) {
      if (isDirty) {
        next(false)
      } else {
        this.$refs.palette.setSelection(type)
        store.dispatch('creator/setSchema', schema[type])
          .then(() => next())
      }
    } else if (resourceType != null && to.params.resourceType !== resourceType) {
      next({
        name: 'eintragen',
        params: {
          resourceType
        }
      })
    } else {
      next()
    }
    // TODO: Move logic from selectedType setter here
  }
}
</script>

<style>
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
  }
  .component-fade-enter, .component-fade-leave-to
  /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .fob-box {
    box-shadow: 0 8px 6px -6px #777;
  }
</style>



// WEBPACK FOOTER //
// src/components/EntityCreate.vue